module.exports = __webpack_public_path__ + "images/embed/next_arrow.png";